import { useLayoutEffect, useRef, useState } from "react";

export function useHeight<T extends HTMLElement>(enabled = true) {
  const ref = useRef<T>(null);
  const [height, setHeight] = useState<number>(0);

  useLayoutEffect(() => {
    if (!enabled) {
      setHeight(0);
      return;
    }

    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeight(entry.contentRect.height);
      }
    });

    observer.observe(element);
    setHeight(ref.current.offsetHeight);

    return () => observer.disconnect();
  }, [enabled]);

  return { ref, height };
}
